import { render, staticRenderFns } from "./FiltersListSticky.vue?vue&type=template&id=3278d8da&scoped=true&"
import script from "./FiltersListSticky.vue?vue&type=script&lang=ts&"
export * from "./FiltersListSticky.vue?vue&type=script&lang=ts&"
import style0 from "./FiltersListSticky.vue?vue&type=style&index=0&id=3278d8da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3278d8da",
  null
  
)

export default component.exports